import { TextField, TextFieldProps } from "@mui/material";
import { ChangeEventHandler, ReactNode } from "react";
import {
  menuItemsToSelectOptions,
  ValutField,
  ValutInput,
  ValutSelect,
} from "../../../Atoms/ValutInput";

type FilterTextFieldProps = TextFieldProps & {
  select?: boolean;
};

function getAdornmentPrefix(InputProps: TextFieldProps["InputProps"]) {
  const adornment = InputProps?.startAdornment;

  if (!adornment || typeof adornment !== "object" || !("props" in adornment)) {
    return undefined;
  }

  return (adornment as { props?: { children?: ReactNode } }).props?.children;
}

export function StyledTextField({
  label,
  select,
  children,
  InputProps,
  variant: _variant,
  size: _size,
  ...rest
}: FilterTextFieldProps) {
  const id = rest.id as string | undefined;
  const fieldLabel = typeof label === "string" ? label : undefined;

  if (select) {
    return (
      <ValutField label={fieldLabel} htmlFor={id}>
        <ValutSelect
          id={id}
          name={rest.name}
          value={rest.value as string | number}
          onChange={
            rest.onChange as unknown as ChangeEventHandler<HTMLSelectElement>
          }
          aria-label={rest["aria-label"] as string | undefined}
          options={menuItemsToSelectOptions(children)}
        />
      </ValutField>
    );
  }

  return (
    <ValutField label={fieldLabel} htmlFor={id}>
      <ValutInput
        id={id}
        name={rest.name}
        type={rest.type}
        value={rest.value as string | number | undefined}
        onChange={rest.onChange}
        placeholder={rest.placeholder}
        aria-label={rest["aria-label"] as string | undefined}
        startAdornment={getAdornmentPrefix(InputProps)}
      />
    </ValutField>
  );
}

export function DatePickerField({ label, ...params }: TextFieldProps) {
  const fieldLabel = typeof label === "string" ? label : undefined;

  return (
    <ValutField label={fieldLabel} htmlFor={params.id as string | undefined}>
      <TextField
        {...params}
        label=""
        hiddenLabel
        variant="outlined"
        size="small"
        fullWidth
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "0.75rem",
            height: "2.75rem",
          },
          "& .MuiOutlinedInput-input": {
            boxSizing: "border-box",
            height: "2.75rem",
            padding: "0 12px",
          },
        }}
      />
    </ValutField>
  );
}
